import React, { FunctionComponent, Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { LoadingSpinner } from './LoadingSpinner';

export const LazyDescriptionEditor: FunctionComponent = (props) => {
  const DescriptionEditor = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "description-editor" */ './DescriptionEditor'
      ),
    { namedImport: 'DescriptionEditor', preload: false },
  );

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <DescriptionEditor {...props} />
    </Suspense>
  );
};
